<div>
  <div class="d-lg-flex align-items-center" rt="top-bar-container">
    <div class="w-auto align-items-end" [class.d-none]="!showSearchInput" [class.d-flex]="showSearchInput">
      <div class="input-group">
        <input type="text" #searchInput class="form-control search" placeholder="Search" rt="common-index-table-search" />
        <i class="icon-mag-glass"></i>
      </div>
    </div>
    <div class="ml-auto mt-3 mt-lg-0">
      <common-icon-button
        *ngIf="addButtonText"
        [routerLink]="['./create']"
        queryParamsHandling="merge"
        iconClass="icon-add"
        [buttonText]="addButtonText"
        rt="common-index-table-add-button"
      ></common-icon-button>
    </div>
  </div>
  <div class="form-row mt-3" *ngIf="countValueFacets?.length">
    <div class="col-lg-3 col-xxl-2" *ngFor="let facet of countValueFacets">
      <common-index-table-facet [facet]="facet" [facetItems]="facet.facets" (apply)="facetApplied($event)"></common-index-table-facet>
    </div>
  </div>

  <div class="card table-card mt-2" rt="table-container" *ngIf="result != null && rows?.length != 0">
    <ng-container *ngIf="showSearchInput">
      <div class="d-flex mb-2 d-lg-none">
        <div class="text-muted side-headings font-weight-light">{{ result.odata.count }} {{ paginationName }}</div>
      </div>
      <div class="card-header d-none d-lg-flex">
        <div class="ml-auto font-weight-light text-muted fs-14">{{ result.odata.count }} {{ paginationName }}</div>
      </div>
    </ng-container>

    <ngx-datatable
      *ngIf="rows?.length > 0"
      rt="table"
      #indexTable
      [rows]="rows"
      [columns]="columns"
      [headerHeight]="50"
      [footerHeight]="125"
      [rowHeight]="rowHeight"
      [columnMode]="columnMode"
      [externalPaging]="externalPaging"
      [footerHeight]="externalPaging"
      [count]="result.odata.count"
      [offset]="offset"
      [limit]="request.top"
      (page)="search($event)"
      [externalSorting]="true"
      (sort)="onSort($event)"
    >
      <ngx-datatable-footer>
        <ng-template
          ngx-datatable-footer-template
          let-rowCount="rowCount"
          let-pageSize="pageSize"
          let-selectedCount="selectedCount"
          let-curPage="curPage"
          let-offset="offset"
          let-isVisible="isVisible"
        >
          <datatable-pager
            [pagerLeftArrowIcon]="'datatable-icon-left'"
            [pagerRightArrowIcon]="'datatable-icon-right'"
            [pagerPreviousIcon]="'datatable-icon-prev'"
            [pagerNextIcon]="'datatable-icon-skip'"
            [page]="curPage"
            [size]="pageSize"
            [count]="rowCount"
            [hidden]="!(rowCount / pageSize > 1)"
            (change)="table.onFooterPage($event)"
          >
          </datatable-pager>
          <div class="page-count" *ngIf="externalPaging">
            {{ pageCountText(pageSize, curPage, rowCount) }}
          </div>
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>
</div>
<ng-template #imageTemplate let-row="row" let-value="value">
  <img class="img-fluid img-fit rounded img-table" *ngIf="!row.imageFailure" [src]="value" (error)="row.imageFailure = true" />
  <div class="align-items-center bg-light d-flex justify-content-center rounded img-table flex-column" *ngIf="row.imageFailure">
    <i class="icon-camera fs-20 mb-1 mt-2 mt-md-0"></i>
    <div>No photo</div>
  </div>
</ng-template>

<ng-template #statusTemplate let-row="row" let-value="value">
  <div class="float-right float-lg-none">
    <common-status-label [status]="value"></common-status-label>
  </div>
</ng-template>

<ng-template #currencyTemplate let-row="row" let-value="value">
  {{ value | currency : "USD" }}
</ng-template>

<ng-template #linkTemplate let-row="row" let-value="value" let-column="column">
  <a class="text-green cursor-pointer" [attr.href]="linkClick(row, column)">{{ value }}</a>
</ng-template>

<ng-template #actionsTemplate let-row="row" let-value="value" let-column="column" let-rowIndex="rowIndex">
  <ng-template
    let-actions="computedActions"
    #selfie
    [ngTemplateOutlet]="selfie"
    [ngTemplateOutletContext]="{ computedActions: getComputedActions(column, row) }"
  >
    <div class="btn-group btn-group-action btn-block" role="group" *ngIf="actions.length">
      <button type="button" class="btn btn-secondary py-2" *ngIf="actions[0].click" (click)="actions[0].click(row)" [attr.rt]="'view-' + rowIndex">
        {{ actions[0].label }}
      </button>
      <a
        class="btn btn-secondary py-2"
        *ngIf="actions[0].routerLink"
        [routerLink]="actions[0].routerLink"
        [queryParams]="actions[0].queryParams"
        [attr.rt]="'view-' + rowIndex"
      >
        {{ actions[0].label }}
      </a>

      <div ngbDropdown container="body" class="d-flex" *ngIf="actions.length > 1">
        <button class="btn btn-secondary more-actions px-2 py-2 align-items-center" ngbDropdownToggle><i class="icon-carrot"></i></button>
        <div class="br-0" ngbDropdownMenu>
          <ng-container *ngFor="let action of actions | slice : 1">
            <button ngbDropdownItem *ngIf="action.click" (click)="action.click(row)" [disabled]="action.disable">{{ action.label }}</button>
            <a ngbDropdownItem *ngIf="action.routerLink" [routerLink]="action.routerLink" [queryParams]="action.queryParams" [disabled]="action.disable">{{
              action.label
            }}</a>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>

<ng-container *ngIf="rows?.length == 0">
  <div class="mt-5 mx-5 text-center">
    <p class="fs-18 text-grey font-weight-light mb-5" [innerHtml]="noResultsMessage || 'There are no ' + paginationName + '.'"></p>
    <img class="img-fluid" src="https://company.rubbl.com//pubweb/marketplace/images/backgrounds/no-results.svg" />
  </div>
</ng-container>
